import { environment } from 'src/environments/environment';

export const TEMPLATES_SV = {
    SUBJECT: 'Yllw Offert ',
    BODY: `
    <h3>Hej RECEIPIENT!</h3>
    <p>Här kommer en offert med nr <strong> QUOTEID </strong> från YLLW. </p>
    <p> Se bifogad offert enligt överenskommelse. Tveka inte att höra av dig om du har några frågor. </p>
    <p></p>
    <p>Vänliga hälsningar,</p>
    <p> <strong> NAME </strong> PHONE <br> MAIL <br><a href="https://yllw.com/" title="https://yllw.com/" target="_blank">www.yllw.com</a></p><p>
    <img src="${environment.frontEndUrl}/assets/images/loggo.jpg" alt="loggo" />`
}

export const TEMPLATES_EN = {
    SUBJECT: 'Yllw Quote ',
    BODY: `
    <h3>Hello RECEIPIENT!</h3>
    <p>Here is a quote with number <strong>QUOTEID</strong> from YLLW.</p>
    <p>Please see the attached quote as agreed. Don’t hesitate to get in touch if you have any questions.</p>
    <p></p>
    <p>Best regards,</p>
    <p> <strong> NAME </strong> PHONE <br> MAIL <br><a href="https://yllw.com/" title="https://yllw.com/" target="_blank">www.yllw.com</a></p><p>
    <img src="${environment.frontEndUrl}/assets/images/loggo.jpg" alt="loggo" />`
}

export const TEMPLATES_FI = {
    SUBJECT: 'Yllw tarjous ',
    BODY: `
    <h3>Hei RECEIPIENT!</h3>
    <p>Tässä on tarjous numerolla <strong>QUOTEID</strong> YLLW:ltä.</p>
    <p>Katso liitteenä oleva tarjous sovitusti. Älä epäröi ottaa yhteyttä, jos sinulla on kysyttävää.</p>
    <p></p>
    <p>Ystävällisin terveisin,</p>
    <p> <strong> NAME </strong> PHONE <br> MAIL <br><a href="https://yllw.com/" title="https://yllw.com/" target="_blank">www.yllw.com</a></p><p>
    <img src="${environment.frontEndUrl}/assets/images/loggo.jpg" alt="loggo" />`
}

export const TEMPLATES_NO = {
    SUBJECT: 'Yllw tilbud ',
    BODY: `
    <h3>Hei RECEIPIENT!</h3>
    <p>Vedlagt finner du tilbud nummer <strong>QUOTEID</strong> fra YLLW.</p>
    <p>Ta gjerne kontakt dersom du har spørsmål.</p>
    <p></p>
    <p>Vennlig hilsen,</p>
    <p> <strong> NAME </strong> PHONE <br> MAIL <br><a href="https://yllw.com/" title="https://yllw.com/" target="_blank">www.yllw.com</a></p><p>
    <img src="${environment.frontEndUrl}/assets/images/loggo.jpg" alt="loggo" />`
}

export const TEMPLATES_DA = {
    SUBJECT: 'Yllw tilbud ',
    BODY: `
    <h3>Hej RECEIPIENT!</h3>
    <p>Her kommer et tilbud med nummer <strong>QUOTEID</strong> fra YLLW.</p>
    <p>Se vedhæftede tilbud som aftalt. Tøv ikke med at kontakte os, hvis du har spørgsmål.</p>
    <p></p>
    <p>Venlig hilsen,</p>
    <p> <strong> NAME </strong> PHONE <br> MAIL <br><a href="https://yllw.com/" title="https://yllw.com/" target="_blank">www.yllw.com</a></p><p>
    <img src="${environment.frontEndUrl}/assets/images/loggo.jpg" alt="loggo" />`
}